import React from "react";
import { Space, Row, Typography, Input, Button } from "antd";

const { Text } = Typography;

export const DepositWithdrawInput = ({
  maxAmount,
  symbol,
  amount,
  setAmount,
}) => {
  const handleInputChange = (e) => {
    setAmount(e.target.value);
  };
  return (
    <Space direction="vertical">
      <Row justify="end">
        <Text>
          {maxAmount} {symbol} Available
        </Text>
      </Row>
      <Input
        type="number"
        value={amount}
        onChange={handleInputChange}
        suffix={
          <div>
            <Text strong>{symbol} </Text> &nbsp;
            <Button
              onClick={() => {
                handleInputChange({ target: { value: maxAmount } });
              }}
            >
              Max
            </Button>
          </div>
        }
      />
    </Space>
  );
};
